export default function Hero() {
  const scrollToMenu = () => {
    const element = document.getElementById('menu');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/725694f3f1efda2b9565f69d84842a48.jpeg"
          alt="らーめん鶴 店外"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 w-full">
        <p className="text-red-400 text-sm tracking-[0.3em] mb-4 font-medium">2026.1.19 GRAND OPEN</p>
        <h1 className="text-8xl font-bold text-white mb-4" style={{ fontFamily: 'serif' }}>
          RAMEN 鶴
        </h1>
        <div className="w-20 h-0.5 bg-red-500 mx-auto mb-6"></div>
        <p className="text-lg text-white/85 font-light tracking-widest mb-2">
          東京・足立区 東伊興
        </p>
        <p className="text-sm text-white/70 tracking-wide mb-10">
          豚骨醤油ラーメン専門店
        </p>
        <button
          onClick={scrollToMenu}
          className="border border-white/60 text-white px-10 py-3 rounded-full text-sm tracking-widest hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          メニューを見る
        </button>
      </div>

      <button
        onClick={scrollToMenu}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 text-white animate-bounce cursor-pointer"
        aria-label="スクロールダウン"
      >
        <i className="ri-arrow-down-line text-4xl"></i>
      </button>
    </section>
  );
}
